import { Box, CircularProgress, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

interface DeviceConnectionStreamContainerComponentProps {
  isEnableVideo?: boolean;
  isError: boolean;
  isLoading: boolean;
  handleVideo: ReactElement;
}

const DeviceConnectionStreamContainerComponent = ({
  isEnableVideo,
  isError,
  isLoading,
  handleVideo,
}: DeviceConnectionStreamContainerComponentProps) => {
  return (
    <Box
      style={{
        width: '100%',
        position: 'relative',
        height: 450,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {!isEnableVideo ? (
        <Typography textAlign={'center'} fontWeight={'bold'} variant={'h4'}>
          Dispositivo offline.
        </Typography>
      ) : isError ? (
        <Box textAlign={'center'}>
          <Typography>
            Dispositivo com problema de conexão, faça as seguintes verificações:
          </Typography>
          <br />
          <br />
          <Typography>
            Se o dispositivo está transmitindo codificado em H.264 ou H.265;
          </Typography>
          <Typography>Se o dispositivo está online; </Typography>
          <Typography>
            Se é possível diminuir a taxa de bits da transmissão;
          </Typography>
          <Typography>Ou pode ser problema de rede (latência).</Typography>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              backgroundColor: 'transparent',
              display: isLoading ? 'flex' : 'none',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
          {handleVideo}
        </>
      )}
    </Box>
  );
};

export default DeviceConnectionStreamContainerComponent;
